// useHandleTap.js
import { useState } from 'react';

const useDoubleTapHandle = (onClick, onDoubleClick, enabledDoubleClick = true, maxTapInterval = 300) => {
  const [, setLastTap] = useState(null);

  const handleTap = () => {
    // this is to avoid the double click
    // trigger when there is no need
    if (!enabledDoubleClick) {
      onClick();
      return;
    }

    const now = Date.now();
    setLastTap(last => {
      if (last && (now - last < maxTapInterval)) {
        onDoubleClick();
      } else {
        
        setTimeout(() => {
          setLastTap(lastTime => {
            if (lastTime === now) {
              onClick();
            }
            return lastTime;
          });
        }, maxTapInterval);

        // Return the current time to update lastTap
        return now;
      }
    });
  };

  return handleTap;
};

export default useDoubleTapHandle;
